// axios二次封装
import axios from 'axios' // 引入 axios
import Vue from 'vue'
import qs from 'qs'
import utils from '@/utils/index'
import store from '@/store'
import { typeJson } from '@/utils/index'

function setLoading(config, status) {
  if (config && config.notLoading) {
    return
  }
  store.dispatch('common/updateApiCount', status)
}

let that = new Vue()
const service = axios.create({
  validateStatus(status) {
    return status >= 200 && status <= 504 // 合法状态码
  },
  baseURL: '/', // 基础请求路径
  timeout: 100000 // 请求超时
})
// 重复尝试此时S
service.defaults.retry = 3
// 重试延时
service.defaults.retryDelay = 15000
// 开启重试
service.defaults.shouldRetry = true
// 请求拦截
service.interceptors.request.use(
  (config) => {
    console.log(config)
    setLoading(config.data, 'add')
    if (
      config.method.toLowerCase() === 'post' &&
      config.data &&
      config.data.formEncode
    ) {
      delete config.data.formEncode
      config.data = qs.stringify(config.data)
    }
    // headers传参
    if (config.data && config.data.headers) {
      config.headers = {
        ...config.headers,
        ...config.data.headers
      }
    }
    if (config.headers && window.wx_code) {
      // weixin code
      config.headers = {
        ...config.headers,
        code: window.wx_code
      }
    }
    return config
  },
  (error) => {
    setLoading(error.config.data, 'sub')
    const {
      response: { statusText }
    } = error
    that.$toast(statusText)
  }
)
// response 拦截器
service.interceptors.response.use(
  (response) => {
    const data = typeJson(response.config.data)
      ? JSON.parse(response.config.data)
      : {}
    setLoading(data, 'sub')
    return new Promise((resolve, reject) => {
      if (response.status !== 200) {
        // 请求失败
        reject(response)
      } else {
        // 成功状态码
        const configUrl = response.config.url
        let { code, msg, msgEng, returnCode, returnMsg, state } = response.data
        if (!code && !returnCode && !msg && !returnMsg) {
          resolve(response) // 文件流
          return
        }
        if (/203|208|209/.test(code)) {
          if (
            window.location.href.indexOf('/world-cup') == -1 &&
            (window.location.href.indexOf('/login') == -1 ||
              configUrl.indexOf('getOpenId') > -1)
          ) {
            utils.setLogined(0)
            that.$toast('请先登录！准备跳转...')
            let st = setTimeout(() => {
              clearTimeout(st)
              utils.redirectToLogin()
            }, 300)
          }
          return
        }
        // 成功状态码
        let successCode = code || returnCode || state
        let codeList = [200, 210, 211, 206, '00', '0000', '9999']
        if (codeList.indexOf(successCode) < 0) {
          that.$toast(msg || msgEng || returnMsg)
        }
        resolve(response)
      }
    }).catch(() => {
      that.$toast(response.status + ' : ' + response.statusText)
    })
  },
  (err) => {
    // 失败
    let message = '请求异常,请检测网络!'
    if (err.response) {
      setLoading(err.response.config.data, 'sub')
      message = err.response.data.message
    } else {
      setLoading({}, 'sub')
    }
    that.$toast(message)
  }
)
export default service
